import React from 'react';
import { Button, List, Menu, Table } from 'semantic-ui-react';

import { Resultados } from 'src/api';
import { LinkAlumno, LinkCurso } from 'src/componentes';
import { InputTimeout } from 'src/componentes/semantic-ui-extended';
import {
    buscarPalabras,
    colapsarEspacios,
    nombreCompletoConNombresPrimero,
    sanearTildes,
} from 'src/utilidades';

type Alumno = Resultados<'alumnosRestringidosDeClases'>['alumnos'][number];
type Curso = Alumno['cursos'][number];
type CursosProps = {
    cursos: ReadonlyArray<Curso>;
};

const cursoStyle = (width: string): React.CSSProperties => ({
    width,
    display: 'inline-block',
});

const DIAS = ['', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes'];

const Cursos: React.FunctionComponent<CursosProps> = props => {
    const { cursos } = props;
    return (
        <List bulleted>
            {cursos.map(({ codigo, dia, bloqueHorario }) => (
                <List.Item key={codigo}>
                    <div style={cursoStyle('6em')}>
                        <LinkCurso codigo={codigo} color='black' />
                    </div>
                    <div style={cursoStyle('11em')}>
                        {DIAS[dia]} {bloqueHorario.horaInicio}-{bloqueHorario.horaTermino}
                    </div>
                </List.Item>
            ))}
        </List>
    );
};

interface Props {
    readonly cargando: boolean;
    readonly alumnos: ReadonlyArray<Alumno>;
    readonly alPresionarRecargar: () => void;
}

interface State {
    readonly textoBusqueda: string;
}

const styleMenuItem: React.CSSProperties = { paddingLeft: '5px' };

export class TablaDeAlumnos extends React.PureComponent<Props, State> {
    public state: State = {
        textoBusqueda: '',
    };

    public render() {
        const { cargando } = this.props;

        const alumnosFiltrados = filtrarAlumnos(this.props.alumnos, this.state.textoBusqueda);

        return (
            <div>
                <Menu borderless size='large' attached='top' style={{ backgroundColor: '#f0f0ff' }}>
                    <Menu.Item fitted style={styleMenuItem}>
                        <Button
                            basic
                            icon='refresh'
                            loading={cargando}
                            onClick={this.props.alPresionarRecargar}
                        />
                    </Menu.Item>

                    <Menu.Item fitted style={styleMenuItem}>
                        <InputTimeout
                            style={{ height: '40px', width: '366px' }}
                            icon='search'
                            placeholder='Escriba un nombre, día o curso'
                            onTimeout={(_e, { value }) => this.setState({ textoBusqueda: value })}
                        />
                    </Menu.Item>

                    <Menu.Item position='right'>{alumnosFiltrados.length} alumnos</Menu.Item>
                </Menu>

                <Table attached='bottom' celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell width={8}>Nombre</Table.HeaderCell>
                            <Table.HeaderCell width={8}>Cursos</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {alumnosFiltrados.map(({ numeroDeMatricula, nombre, cursos }) => (
                            <Table.Row key={numeroDeMatricula}>
                                <LinkAlumno
                                    numeroDeContrato={numeroDeMatricula}
                                    nombre={nombre}
                                    paraTabla
                                />

                                <Table.Cell>
                                    <Cursos cursos={cursos} />
                                </Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
            </div>
        );
    }
}

function filtrarAlumnos(alumnos: ReadonlyArray<Alumno>, criterio: string) {
    let textoBusqueda = criterio;
    textoBusqueda = sanearTildes(colapsarEspacios(textoBusqueda)).toLowerCase();

    return textoBusqueda !== ''
        ? alumnos.filter(
              fila =>
                  buscarPalabras(
                      sanearTildes(nombreCompletoConNombresPrimero(fila.nombre)).toLowerCase(),
                      textoBusqueda,
                  ) ||
                  fila.cursos.some(
                      curso =>
                          sanearTildes(curso.codigo)
                              .toLowerCase()
                              .startsWith(textoBusqueda) ||
                          sanearTildes(DIAS[curso.dia])
                              .toLowerCase()
                              .startsWith(textoBusqueda),
                  ),
          )
        : alumnos;
}



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/Restringidos/componentes/TablaDeAlumnos.tsx